import React from 'react';
import PropTypes from 'prop-types';
import BarChartWithThreshold from './BarChartWithThreshold';
import { chartTheme } from './chartTheme';

const BarChartCompletion = ({ data }) => {
  return (
    <BarChartWithThreshold
      data={data}
      title="Assignment Completion by Section"
      series={[
        {
          dataKey: 'percentCompleted',
          name: 'Completed Assignments',
          color: chartTheme.main,
          stackId: 'a',
        },
        {
          dataKey: 'percentMissed',
          name: 'Missed Assignments',
          color: chartTheme.secondary,
          stackId: 'a',
        },
      ]}
    />
  );
};

export default BarChartCompletion;

BarChartCompletion.propTypes = {
  data: PropTypes.shape({
    sections: PropTypes.array,
  }).isRequired,
};
